import React, {Component} from "react";  import config from 'react-global-configuration';
import axios from "axios";
import "../assets/css/monthpicker/month-picker.css";
import NotificationSystem from "react-notification-system";
import {style} from "variables/Variables.jsx";
import {css} from "@emotion/core";
import {BeatLoader} from 'react-spinners';
import jwt_decode from "jwt-decode";
import $ from "jquery";

const override = css `
    display: block;
    margin: 0 auto;
    border-color: red;
`;
class UploadFiles extends Component{
    constructor(props) {
        super(props);
        this.state = {
            selectedFile: null,
            uploadTypeFile: '',
            _notificationSystem: null,
            loading:false,
            isSubmit:false,
            tableData: [],
            tableView: false,
            data_table:'',
            result_data:[],
            file_name:'',
            file_path:'',
            uploadSuccess: false,
            isChange: false,
            usr_file_type:''
        }

    }
    handleNotificationClick = (position, color, msg) => {
        var level;
        switch (color) {
            case 1:
                level = "success";
                break;
            case 2:
                level = "warning";
                break;
            case 3:
                level = "error";
                break;
            case 4:
                level = "info";
                break;
            default:
                break;
        }
        this.state._notificationSystem.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift" />,
            message: (
                <div>
                    {msg}
                </div>
            ),
            level: level,
            position: position,
            autoDismiss: 5
        });
    };
    componentDidMount() {
        console.log(config.get('API_URL'));
        this.setState({ _notificationSystem: this.refs.notificationSystem });
        var _notificationSystem = this.refs.notificationSystem;
    }
    getFileExtension(filename) {
        return (/[.]/.exec(filename)) ? /[^.]+$/.exec(filename)[0] : undefined;
    }

    onChangeHandler=event=>{
        var file = event.target.files[0];
        var ext = this.getFileExtension(file.name);
         if(ext=='xlsx' || ext=='xls') {
             this.setState({
                 selectedFile: file
             });
         } else{
             this.handleNotificationClick("tr", 3, "Please upload valid file");
             this.setState({
                 selectedFile: file
             });
         }

    };
    fileUploadHandler = () => {


        //$("#DetailsTable").on('mousedown.edit', "i.fa.fa-pencil-square", function(e) { alert("hii");


        if(this.state.selectedFile===null) {
            this.handleNotificationClick("tr", 3, "Please upload valid file");
            return false;
        }
        this.setState({
            isSubmit:true,
            loading:true,

        });
        var monthly = this.state.mvalue;
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        const data = new FormData();
        data.append('file', this.state.selectedFile);
        data.append('fileType', this.state.uploadTypeFile);
        data.append('userID', decoded.email);
        var file = this.state.selectedFile; //console.log(data);
        var ext = this.getFileExtension(file.name);
        if(ext=='xlsx' || ext=='xls') {
            axios.post(config.get('API_URL')+"/anycardemi/upload/", data,{
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            })
                .then(res => {
                    console.log("tablesss");
                    console.log(res);
                    if(res.data.success){
                        //this.handleNotificationClick("tr", 1, res.data.success);
                        var table = $('#DetailsTable').DataTable({
                            "bPaginate": false,
                            //"pageLength": 30,
                            "searching": false,
                            "lengthChange": false,

                        });
                        this.setState({
                            tableView:true,
                            isSubmit:false,
                            loading:false,
                            tableData: res.data.data,
                            uploadTypeFile:'',
                            data_table: table,
                            result_data: res.data,
                            file_name: res.data.file_name,
                            file_path:  res.data.file_path
                         });
                    } else {
                        this.handleNotificationClick("tr", 3, res.data.error);
                        this.setState({
                            isSubmit:false,
                            loading:false
                        })
                    }


                    $('#DetailsTable tbody').on('click', 'td.edit-control', function () {
                        //alert("hi");
                        var $row = $(this).closest("tr").off("mousedown");
                        var $tds = $row.find("td").not(':first').not(':last');

                        $.each($tds, function(i, el) {
                            var txt = $(this).text();
                            $(this).html("").append("<input type='text' class='editTableInput' value=\""+txt+"\">");
                        });

                    });
                })
                .catch(err => { // then print response status
                    //this.handleNotificationClick("tr", 3, "Something Wrong!");
                    this.setState({
                        isSubmit:false,
                        loading:false
                    })
                })
        }
        else{
            this.handleNotificationClick("tr", 3, "Please upload valid file");
            this.setState({
                isSubmit:false,
                loading:false
            })
        }
    };

    uploadType(type, e){
        this.setState({
            uploadTypeFile:type,
            usr_file_type:type
        })
    }
    createUTID(e) {
        this.setState({
            loading:true,
            isChange: true
        });
        var emi_type = '';
        if(this.state.usr_file_type == 'anyCardEMI') {
            emi_type = 'anybank';
        }
        else {
            emi_type = 'easy';
        }
        var myRows = [];
        var $headers = $("th");
        var $rows = $("#DetailsTable tbody tr").each(function(index) {
        var $cells = $(this).find("td.mydataCls");
            myRows[index] = {};
            $cells.each(function(cellIndex) {
                var ss = $(this).find('input:text');
                if (ss.val() !== undefined) {
                    var keys = '';
                    if($($headers[cellIndex]).html()=='EMI TID'){
                        keys = 'New INNOVITI TID (570 Series)';
                    }
                    else if($($headers[cellIndex]).html()=='Merchant Name'){
                        keys = 'ME NAME';
                    }
                    myRows[index][keys] = ss.val();
                } else {
                    var keys1 = '';
                    if($($headers[cellIndex]).html()=='EMI TID'){
                        keys1 = 'New INNOVITI TID (570 Series)';
                    }
                    else if($($headers[cellIndex]).html()=='Merchant Name'){
                        keys1 = 'ME NAME';
                    }
                    myRows[index][keys1] = $(this).html();
                }
            });
        });
        var myObj = {};
        myObj.myrows = myRows;
       //console.log(myObj.myrows);
       var object1 = this.state.tableData;
       console.log(object1);
       // this.state.result_data.map((k,index) => {
       //
       // });
       // $.extend( true, object1, myObj )
        $.extend( true, object1, myObj.myrows );
        //console.log(object1);
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        axios.post(config.get('API_URL')+'/anycardemi/save-excel-data/',
            {
                data: object1,
                email: decoded.email,
                file_name: this.state.file_name,
                file_path: this.state.file_path,
                emi_type: emi_type
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },
            })
            .then(response => {
                console.log("disableeeee");
                console.log(response);
                if(response.data.data=='OK') {
                    this.setState({
                        uploadSuccess: true,
                        tableView: false,
                        uploadTypeFile: '',
                        loading:false,
                        isChange: false
                    });
                    this.handleNotificationClick("tr", 1, "Uploaded Successfully");
                }
            }).catch( err=> {
            console.log(err);
        })
    }
    render() {
        let typeTitle = '';
        if(this.state.uploadTypeFile=='anyCardEMI'){
            typeTitle = "Any Card EMI"
        } else if(this.state.uploadTypeFile=='easyEMI'){
            typeTitle = "Easy EMI"
        }

        let Tabledata = this.state.tableData.map((val,index) => {

                return (
                    <tr key={index + 1}>
                        <td className="mydataCls">{val["Base TID"]}</td>
                        <td className="mydataCls">{val["New INNOVITI TID (570 Series)"]}</td>
                        <td className="mydataCls">{val.Tenure}</td>
                        <td className="mydataCls">{val.ROI}</td>
                        {/*<td>{val.Base_TID}</td>*/}
                        <td className="mydataCls">{val["ME NAME"]}</td>
                        <td className="mydataCls">{val.Pincode}</td>
                        <td className="mydataCls">{val.City}</td>
                        <td className="mydataCls">{val.State}</td>
                        <td className="edit-control"><i className="fa fa-pencil-square" aria-hidden="true"></i>
                            </td>
                        {/*<td>{val.Merchant}</td>*/}
                        {/*<td>{val.Branch}</td>*/}
                        {/*<td>{val.Base_TID}</td>*/}
                        {/*<td>{val.new_innoviti_tid}</td>*/}
                        {/*<td>{val.Merchant}</td>*/}
                        {/*<td>{val.Branch}</td>*/}
                        {/*<td>{val.Base_TID}</td>*/}
                        {/*<td>{val.new_innoviti_tid}</td>*/}
                        {/*<td>{val.Merchant}</td>*/}
                    </tr>
                )

        });
        return(
            <div className="content">
                <NotificationSystem ref="notificationSystem" style={style} />
                <div className="container-fluid">
                    <div className="row">

                        {this.state.uploadTypeFile=='' && this.state.tableView===false && this.state.uploadSuccess===false?
                        <div className="header">
                            <h4 className="titleAnyCart">Select EMI Type</h4>
                            <p className="categoryEmi">Kindly Select the type of EMI for your File Upload</p>
                        </div>: null }
                        <div className="">
                            {this.state.uploadTypeFile=='' && this.state.tableView===false && this.state.uploadSuccess===false?
                                <React.Fragment>
                                    <div className="botton_emi"><button type="button" className="btn btn-primary center-button" onClick={this.uploadType.bind(this,'anyCardEMI')}>ANY CARD EMI</button></div>
                                     <div className="botton_emi"><button type="button" className="btn btn-primary center-button"onClick={this.uploadType.bind(this, 'easyEMI')}>EASY EMI</button></div>
                                </React.Fragment>
                            : null }
                            {this.state.uploadTypeFile!='' && this.state.uploadSuccess===false?
                                <React.Fragment>
                                    <div className="col-md-3 back-arrow-div">
                                        <a href="#" onClick={this.uploadType.bind(this,'')}><i className="fa fa-angle-left" aria-hidden="true"></i></a>
                                    </div>
                                        <div className="col-md-6">

                                            <form method="post" action="#" id="#">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <div className="header">
                                                            <h4 className="titleAnyCart">Upload File - {typeTitle}</h4>
                                                            <p className="categoryEmi">Kindly upload the file with the details</p>
                                                            <br/>
                                                        </div>
                                                        <div className="centerAlign">
                                                        <input type="file" name="file" className="form-control anycardFile" onChange={this.onChangeHandler} />
                                                        </div>
                                                    </div>
                                                    <div className="form-group"><br/>
                                                        <div className="botton_emi">
                                                            <button width="100%" type="button" className="btn btn-primary" onClick={this.fileUploadHandler} disabled={this.state.isSubmit}>Upload File</button>
                                                        </div>
                                                        <div className='sweet-loading'>
                                                            <BeatLoader
                                                                css={override}
                                                                sizeUnit={"px"}
                                                                size={20}
                                                                color={'#123abc'}
                                                                loading={this.state.loading}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                                {/*<div className="col-md-3 pull-left">*/}
                                                {/*    */}
                                                {/*</div>*/}
                                                <div className="clearfix"></div>
                                            </form>
                                        </div>
                                    <div className="col-md-3"></div>
                                </React.Fragment>
                                : null }

                            <div className="clearfix"></div>

                            {this.state.tableView===true?
                                <div>

                                    <div className="row">
                                        <h4 className="centerAlign nomargin">FILE CHECK</h4>
                                        {/*<div className="col-md-4">*/}
                                        {/*    <div className="col-md-5"><label>INN Request No:</label></div>*/}
                                        {/*        <div className="col-md-7"><input type="text"/></div>*/}
                                        {/*</div>*/}
                                        {/*<div className="col-md-4">*/}
                                        {/*    <div className="col-md-5"><label>EMI TYPE:</label></div>*/}
                                        {/*    <div className="col-md-7">{this.state.uploadTypeFile}</div>*/}
                                        {/*</div>*/}
                                        {/*<div className="col-md-4">*/}
                                        {/*    <div className="col-md-5"><label>Uploaded File:</label></div>*/}
                                        {/*    <div className="col-md-7"><input type="text"/></div>*/}
                                        {/*</div>*/}
                                    </div>

                                <div className="row">
                                    <div className="ro-sep"></div>
                                </div>

                            <div className="content-tdetails-table table-full-width table-responsive">
                                <table id="DetailsTable" className="table table-striped table-hover">
                                    <thead>
                                        <tr>
                                            <th>Base TID</th>
                                            <th>EMI TID</th>
                                            <th>Tenure</th>
                                            <th>ROI</th>
                                            {/*<th>Call ID</th>*/}
                                            <th>Merchant Name</th>
                                            <th>Pincode</th>
                                            <th>City</th>
                                            <th>State</th>
                                            <th></th>
                                            {/*<th>ROI</th>*/}
                                            {/*<th>Advance EMI New</th>*/}
                                            {/*<th>Proc Fee New</th>*/}
                                            {/*<th>MCC Code</th>*/}
                                            {/*<th>TID Type (POS/PG)</th>*/}
                                            {/*<th>Brand EMI subvention enabled? Y/N</th>*/}
                                            {/*<th>Brand Name</th>*/}
                                            {/*<th>Email id</th>*/}
                                            {/*<th>Promo Code</th>*/}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Tabledata}
                                    </tbody>

                                </table>
                                <div className="gap_ver"></div>
                                <div className="col-md-3 pull-right">
                                    {/*<button width="100%" type="button" className="btn btn-secondary">Cancel</button> &nbsp;*/}
                                    <button width="100%" type="button" className="btn btn-primary" onClick={this.createUTID.bind(this)} disabled={this.state.isChange}>Create UTID</button>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={20}
                                        color={'#123abc'}
                                        loading={this.state.loading}
                                    />
                                </div>

                                <div className="clearfix"></div>
                                <div className="gap_ver"></div>
                            </div>
                            </div>: null }
                            {this.state.uploadSuccess===true?
                                <div>
                                    <div className="col-md-4 "></div>
                                    <div className="col-md-4 smessage">
                                        <h4>Congratulations!!!</h4>
                                        <p>Your Request Number</p>
                                        <p>has been received Successfully.</p>
                                        <p>UTID's Will be configured within 48 hours.</p>
                                    </div>
                                    <div className="col-md-4"></div>
                                </div>
                                : null }
                            <div className="footer">
                                <div className="stats"><i></i>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        );
    }

}

export default UploadFiles